import React from 'react';
import ActivitySection from './activity-section';
import styles from './index.module.scss';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import { ReviewSubjectDto } from '@interfaces-clean/subject-monitoring/subject-review';
import ReviewProgressCardsList from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-progress-cards-list';

type Props = {
    studyRef: string;
    review: EditReviewDto;
    reviewSubjects: ReviewSubjectDto[];
};

const SMActiveReviewTabActivityTab = ({ studyRef, review, reviewSubjects }: Props) => {
    return (
        <div className={styles.grid}>
            <ReviewProgressCardsList studyRef={studyRef} review={review} reviewSubjects={reviewSubjects} />

            <ActivitySection studyRef={studyRef} reviewId={review.id as number} />
        </div>
    );
};

export default SMActiveReviewTabActivityTab;
